// File: src/pages/mentor-park/MentorParkHome.jsx
// Description: Landing page for Mentor Park

import React from 'react';
import { Box, Card, CardContent, Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const sections = [
  { path: '/mentor-park/career-insights', title: 'Career Insights', desc: 'Analyze trajectory, trends, and next steps.' },
  { path: '/mentor-park/skill-gap', title: 'Skill Gap Analysis', desc: 'Identify gaps and target learning paths.' },
  { path: '/mentor-park/personalized', title: 'Personalized Insights', desc: 'Get tailored guidance for your goals.' },
  { path: '/mentor-park/tools', title: 'Career Tools & Preparation', desc: 'Interview prep, resume tips, and more.' },
  { path: '/mentor-park/resources', title: 'Resources & Certifications', desc: 'Courses and certifications to advance.' },
  { path: '/mentor-park/job-alignment', title: 'Job Alignment Analysis', desc: 'Analyze alignment between your profile and job requirements.' },
  { path: '/mentor-park/community', title: 'Community & Networking', desc: 'Connect, share, and grow together.' }
];

const MentorParkHome = () => {
  return (
    <Box>
      <Grid container spacing={2}>
        {sections.map((s) => (
          <Grid item xs={12} md={6} lg={4} key={s.path}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>{s.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{s.desc}</Typography>
                <Button component={Link} to={s.path} variant="contained">
                  Open
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MentorParkHome;


